<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>批发物流&发货信息参数</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>批发物流&发货信息参数</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>批发物流规则设置</p>
            <div class="radio_box">
              <el-radio-group
                v-model="formData.runtype"
                @input="handleInputRuleType"
              >
                <el-radio label="1">统一按标准收取</el-radio>
                <el-radio
                  label="2"
                  :disabled="
                    formData.orderrule == 2 || formData.specialarea == 2
                  "
                  >免物流费用</el-radio
                >
                <el-radio label="3">部分地区免物流费用</el-radio>
                <el-radio
                  label="4"
                  :disabled="
                    formData.orderrule == 2 || formData.specialarea == 2
                  "
                  >到付</el-radio
                >
              </el-radio-group>
            </div>
            <div
              class="check_box"
              style="margin-top: 15px"
              v-if="formData.runtype == 3"
            >
              <p style="font-size: 12px">
                <span class="mark" style="font-size: 12px">*</span
                >免物流费的特殊地区
              </p>
              <el-checkbox-group
                v-model="ruleCheck"
                direction="horizontal"
                @change="changeLabel"
              >
                <el-checkbox
                  v-for="item in cityList"
                  :label="item.areaid"
                  :key="item.areaid"
                  :disabled="isDisabled(item)"
                  >{{ item.areaname }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>特殊订单规则设置</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.orderrule">
                <el-radio label="1">无特殊规则</el-radio>
                <el-radio label="2" :disabled="formData.runtype == 2"
                  >按照商品数量免物流费</el-radio
                >
              </el-radio-group>
            </div>
            <div
              class="input_box"
              style="margin-top: 15px"
              v-if="formData.orderrule == 2"
            >
              <p style="font-size: 12px">
                <span class="mark" style="font-size: 12px">*</span>超过[]件商品
                免物流费（/件）
              </p>
              <el-input
                v-model="formData.goodsfullnum"
                placeholder="请输入数量"
                type="digit"
              />
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>特殊地区规则设置</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.specialarea">
                <el-radio label="1">无特殊地区</el-radio>
                <el-radio label="2" :disabled="formData.runtype == 2"
                  >特殊地区物流费用增加[]%</el-radio
                >
              </el-radio-group>
            </div>
            <template v-if="formData.specialarea == 2">
              <div class="input_box" style="margin-top: 15px">
                <p style="font-size: 12px">
                  <span class="mark" style="font-size: 12px">*</span
                  >特殊地区费用增加百分比（% 填写一个1=100的数字）
                </p>
                <el-input
                  v-model="formData.pernum"
                  placeholder="请填写特殊地区费用增加百分比"
                  min="1"
                  max="100"
                  type="digit"
                />
              </div>
              <div
                class="check_box"
                style="margin-top: 15px"
                v-if="formData.specialarea == 2"
              >
                <p style="font-size: 12px">
                  <span class="mark" style="font-size: 12px">*</span>特殊地区
                </p>
                <el-checkbox-group
                  v-model="pernumCheck"
                  direction="horizontal"
                  @change="changeLabel1"
                >
                  <el-checkbox
                    v-for="item in cityList"
                    :label="item.areaid"
                    :key="item.areaid"
                    :disabled="isDisabled1(item)"
                    >{{ item.areaname }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { getProvince, encryptstringview } from "../../../api/api";
import {
  addShopPfLogistics,
  editShopPfLogistics,
  getShopPfLogisticsList,
} from "../../../api/shop";
export default {
  name: "addRulePf",
  data() {
    return {
      loading: false,
      cityList: [],
      ruleCheck: [], // 免物流特殊地区
      pernumCheck: [], //  特殊地区费用
      formData: {
        id: "",
        qyguid: "",
        cmid: "",
        runtype: "", // 物流规则设置
        province: "", // 免物流的特殊地区
        orderrule: "", // 特殊订单规则设置
        goodsfullnum: 0, // 超过[]件商品，免费物流
        specialarea: "", // 特殊地区规则设置
        pernum: 0, // 特殊地区费用增加百分比
        specialprovince: "", // 特殊地区
      },
    };
  },
  computed: {
    isDisabled() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.pernumCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
    isDisabled1() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.ruleCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.getProvince();
        this.getShopPfLogisticsList();
      } else {
        this.$router.back();
      }
    },

    // 获取物流信息
    getShopPfLogisticsList() {
      let qyguid = this.formData.qyguid;
      let params = {
        cmid: this.formData.cmid,
        pageindex: 1,
        pagesize: 100,
      };
      getShopPfLogisticsList(params).then((res) => {
        if (res.list.length > 0) {
          res.list.forEach((v) => {
            if (v.qyguid == qyguid) {
              this.formData.id = v.id ? v.id : "";
              this.formData.runtype = v.runtype ? v.runtype : "";
              this.formData.province = v.province ? v.province : "";
              let stringProvince = v.province ? v.province.split(",") : [];
              this.ruleCheck = stringProvince.map((str) => parseInt(str));
              this.formData.orderrule = v.orderrule ? v.orderrule : "";
              this.formData.goodsfullnum = v.goodsfullnum ? v.goodsfullnum : 0;
              this.formData.specialarea = v.specialarea ? v.specialarea : "";
              this.formData.pernum = v.pernum ? v.pernum : 0;
              this.formData.specialprovince = v.specialprovince
                ? v.specialprovince
                : "";
              let stringSpecialprovince = v.specialprovince
                ? v.specialprovince.split(",")
                : [];
              this.pernumCheck = stringSpecialprovince.map((str) =>
                parseInt(str)
              );
            }
          });
        }
      });
    },
    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.cityList = res;
      });
    },
    // 免物流特殊地区
    changeLabel() {
      this.formData.province = this.ruleCheck.join(",");
    },
    // 免物流特殊地区
    changeLabel1() {
      this.formData.specialprovince = this.pernumCheck.join(",");
    },
    // 单选-物流类型
    handleInputRuleType(e) {
      if (e == 2) {
        this.ruleCheck = [];
        this.pernumCheck = [];
        if (this.formData.orderrule == 2) {
          this.formData.orderrule = "";
          this.formData.goodsfullnum = "";
        }
        if (this.formData.specialarea == 2) {
          this.formData.specialarea = "";
          this.formData.pernum = "";
          this.formData.specialprovince = "";
        }
      }
    },

    query() {
      let { formData } = this;
      if (formData.runtype == "") {
        this.$message.warning("请选择物流规则设置");
        return;
      }
      if (formData.orderrule == "") {
        this.$message.warning("请选择特殊订单规则设置");
        return;
      }
      if (formData.specialarea == "") {
        this.$message.warning("请选择特殊地区规则设置");
        return;
      }
      if (formData.runtype == 3 && formData.province == "") {
        this.$message.warning("请选择免物流费的特殊地区");
        return;
      }
      if (formData.orderrule == 2 && formData.goodsfullnum == "") {
        this.$message.warning("请填写商品件数");
        return;
      }
      if (formData.specialarea == 2 && formData.pernum == "") {
        this.$message.warning("请填写特殊地区费用增加百分比");
        return;
      }
      if (formData.specialarea == 2 && formData.specialprovince == "") {
        this.$message.warning("请选择特殊地区");
        return;
      }
      this.loading = true;
      if (formData.id != "") {
        editShopPfLogistics(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopPfLogistics(formData).then((res) => {
          if (res.result) {
            // this.loading = false;
            // let message = this.$message.success(res.message);
            // setTimeout(() => {
            //   message.close();
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },

    handleReturn() {
      // history.back();
      this.$router.push({name: 'cManageIndex'})
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>